<div>
    <div class="flex-justify-between flex-align-center flex py-2">
        <div
            class="text-xs font-semibold uppercase text-ironside_grey dark:text-contrast-yellow"
            [class.normal-case]="env.REMOVE_UPPERCASE">
            {{ 'RECENTS' | translate }}
        </div>
        <ion-button
            class="var-app-light:text-primary var-app-light-dark:text-xm text-xs font-semibold normal-case text-secondary dark:text-contrast-yellow"
            [attr.aria-label]="'RECENTS_CLEAR' | translate"
            (click)="clear.emit()"
            size="small"
            fill="clear">
            {{ 'RECENTS_CLEAR' | translate }}
        </ion-button>
    </div>

    <ng-container *ngFor="let recent of recents">
        <div class="border-ironside_grey-100 border-t border-solid dark:border-contrast-yellow"></div>
        <rwidget-search-item
            [searchItem]="recent"
            [searchText]="searchText"
            (select)="select.emit($event)"></rwidget-search-item>
    </ng-container>
</div>
